import { memo } from 'react';
import styles from './stamp.module.css';

export type StampTone = 'victim' | 'arrest';

export interface StampProps {
  text: string;
  sub?: string;
  tone?: StampTone;
  /** Animation « le tampon tombe » (game over). */
  drop?: boolean;
  /** Délai avant l’animation drop (ms). */
  dropDelayMs?: number;
  /** État final sans animation (skip / reduced-motion). */
  instant?: boolean;
  className?: string;
}

export const Stamp = memo(function Stamp({
  text,
  sub,
  tone = 'victim',
  drop = false,
  dropDelayMs = 0,
  instant = false,
  className,
}: StampProps) {
  const toneClass = tone === 'arrest' ? styles.arrest : styles.victim;
  const dropStyle =
    drop && !instant && dropDelayMs > 0
      ? ({ animationDelay: `${dropDelayMs}ms` } as const)
      : undefined;

  return (
    <div
      className={[
        styles.stamp,
        toneClass,
        drop && !instant ? styles.drop : '',
        instant ? styles.instant : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      style={dropStyle}
      aria-hidden
    >
      {text}
      {sub ? <span className={styles.sub}>{sub}</span> : null}
    </div>
  );
});
